import React from "react";
import CartItem from "../../components/Website/CartItem";
import CartDetails from "../../components/Website/CartDetails";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { languageHelper } from "../../config/helperFunctions";

function MyCart() {
  const cart = useSelector((state) => state.products.cart);

  if (cart.length === 0) {
    return (
      <section className="max-w-7xl w-[90%] mx-auto min-h-[60vh]">
        <h2 className="text-2xl font-semibold mt-16">{languageHelper("my cart") || "My Cart"}</h2>
        <p>{languageHelper("cart is empty") || "Cart is empty"}</p>
      </section>
    );
  }
  return (
    <section className="max-w-7xl w-[90%] mx-auto flex justify-center flex-col lg:flex-row pb-16">
      <div className="w-full lg:w-3/4">
        {cart.map((item, index) => (
          <CartItem key={index} data={item} idx={index} />
        ))}
        {/* <CartItem />
        <CartItem /> */}
        <div className="flex justify-center w-fit flex-col text-w-btn-text font-bold text-lg rounded-md py-2 px-4 mt-5 border border-w-border bg-w-btn">
          <Link to={"/"} className="flex justify-center">
            {languageHelper("continue to add more") || "Continue To Add More"}
          </Link>
        </div>
      </div>
      <div className="w-full lg:w-1/4">
        <CartDetails />
      </div>
    </section>
  );
}

export default MyCart;
